import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    country: [],
    loading: false,
    error: null,
};

const countryListtSlice = createSlice({
    name: 'countryListt',
    initialState,
    reducers: {
        countryListtRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        countryListtSuccess: (state, action) => {
            state.loading = false;
            state.country = action.payload;
            state.error = null;
        },
        countryListtFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { countryListtRequest, countryListtSuccess, countryListtFailure } = countryListtSlice.actions;

export default countryListtSlice.reducer;